module.exports = __webpack_public_path__ + "assets/img/remote.f606f198.png";